import axios from 'axios'

const baseURL = process.env.VUE_APP_API_URL
// const find = require('lodash/find')

const state = {
  about: null,
  developments: null,
  plots: null,
  purchaseOptions: null
}

const getters = {
  getDevelopment: (state) => (id) => {
    if (!state.developments) {
      return null
    }
    return state.developments.find(development => development.id === id)
  },
  getPlots: (state) => (crm) => {
    const development = state.plots.find(development => development.id === crm)
    return development.plots
  }
}

const mutations = {
  setContent (state, payload) {
    state.about = payload.about
    state.developments = payload.developments
    state.plots = payload.plots
    state.purchaseOptions = payload.purchaseOptions
  }
}

const actions = {
  getContent ({ commit, state }) {
    axios.get(baseURL + '/api/content', {
      auth: {
        username: 'laurushomes@popcomms.com',
        password: 'AmZTVZyFf72GTrjfkV7xbDzJ'
      }
    })
      .then(function (response) {
        commit('setContent', response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
